export const PAGE_ALIASES = {
  Scheduler: 'Reels Operations',
  'Reddit Dashboard': 'Reddit Operations',
  'CUZO Brain': 'Knowledge',
  'User Management': 'Settings',
};

export const normalizePageLabel = label => PAGE_ALIASES[label] || label;

export function normalizeCustomPages(pages) {
  if (pages === null || pages === undefined) return null;
  let parsed = pages;
  if (typeof pages === 'string') {
    try { parsed = JSON.parse(pages); } catch (_) { return null; }
  }
  if (!Array.isArray(parsed)) return null;
  return [...new Set(parsed.filter(page => typeof page === 'string').map(normalizePageLabel))];
}

export function hasPageAccess(customPages, page) {
  const normalized = normalizeCustomPages(customPages);
  return normalized === null || normalized.includes(normalizePageLabel(page));
}

const ROUTES = {
  'Command Center': '/command-center',
  'Reels Operations': '/reels-operations',
  Tasks: '/tasks',
  'Chatters CRM': '/chatters',
  'Sales Overview': '/sales-overview',
  'Sunday Review': '/review',
  Pipeline: '/pipeline',
  'Content OS': '/content-os',
  Knowledge: '/knowledge',
  'AI Generator': '/ai-content',
  'Reddit Operations': '/reddit-dashboard',
  'Send Alert': '/telegram',
  Documents: '/documents',
  Settings: '/settings',
  Finance: '/finance',
  'Model Onboarding': '/onboarding',
  'Models Hub': '/models-hub',
};

const ROLE_ORDER = {
  owner: Object.keys(ROUTES),
  va: ['Reels Operations', 'Tasks', 'Content OS', 'Knowledge', 'AI Generator', 'Reddit Operations', 'Send Alert', 'Documents', 'Model Onboarding', 'Models Hub'],
  chatter: ['Chatters CRM', 'Tasks', 'Knowledge', 'Documents'],
};

export function defaultRouteForUser(user) {
  if (!user) return '/login';
  const available = normalizeCustomPages(user.custom_pages);
  const labels = ROLE_ORDER[user.role] || [];
  const first = available === null ? labels[0] : labels.find(label => available.includes(label));
  return ROUTES[first] || '/login';
}
